import { AppConstants } from '../appConstant';

export class RedirectNavigation {
    static logoutUrl: string | null = null;

    static onRedirectNavigate(url: string) {
        if (url?.startsWith(AppConstants.LogoutMSALADURL)) {
            RedirectNavigation.logoutUrl = url;
            return false;
        }
        return true;
    }
}
